module.exports = __webpack_public_path__ + "img/1440.093a3678.jpg";